import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const REPORT_CARD_LINKS = [
  { to: "/reportcard/settings", label: "Settings" },
  { to: "/reportcard/co-scholastic", label: "Co-Scholastic Grades" },
  { to: "/reportcard/footer", label: "Remarks & Footer" },
  { to: "/reportcard/publish", label: "Preview & Publish" },
];

/** Common page frame: breadcrumb + quick links between report card screens */
const PageShell = ({ title, children }) => (
  <>
    <Helmet><title>{title}</title></Helmet>
    <ToastContainer position="top-right" autoClose={2000} theme="light" />
    <Row className="g-0">
      <Col lg={12} className="px-3 d-flex flex-wrap justify-content-between align-items-center">
        <div className="nav-link mx-2">
          <Link to="/" className="text-decoration-none">Home</Link> <i className="fa-solid fa-chevron-right"></i>{" "}
          <Link to="/examlist" className="text-decoration-none">Exam List</Link> <i className="fa-solid fa-chevron-right"></i> {title}
        </div>
        <div className="d-flex flex-wrap gap-1 my-2">
          {REPORT_CARD_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className={`btn btn-sm ${window.location.pathname === l.to ? "btn-primary" : "btn-outline-secondary"}`}>
              {l.label}
            </Link>
          ))}
        </div>
      </Col>
      <Col lg={12} className="p-lg-4 p-2">{children}</Col>
    </Row>
  </>
);

export default PageShell;
